import { commonServerInstance } from '@/utilities/instances'

// Interface for Partner Carrier data structure
export interface IPartnerCarrier {
  id: number
  partner: string
  carrier: string
  binding_status: string
  status_key: string
  start_time: string
  end_time: string
  page?: string
  per_page?: string
}

export const fetchPartnerCarriers = async (
  filters: Partial<IPartnerCarrier>
) => {
  const response = await commonServerInstance.post(
    '/api/v1/ca/rate-card/partner-carrier-config/search',
    filters
  )
  return response?.data?.data
}

export const fetchPartnersInPartnerCarrier = async () => {
  const response = await commonServerInstance.get(
    '/api/v1/ca/rate-card/partner-carrier-config/partners'
  )
  return response?.data?.data
}

export const fetchCarriersInPartnerCarrier = async (include_uniuni?: 1) => {
  const response = await commonServerInstance.get(
    `/api/v1/ca/rate-card/partner-carrier-config/carriers?include_uniuni=${include_uniuni}`
  )
  return response?.data?.data
}

export const fetchEnumOptions = async () => {
  const response = await commonServerInstance.get(
    '/api/v1/ca/rate-card/partner-carrier-config/enum-options'
  )
  return response?.data?.data
}

export const updateCarrier = async (data: any) => {
  const response = await commonServerInstance.put(
    `/api/v1/ca/rate-card/partner-carrier-config/update`,
    data
  )
  return response?.data?.data
}

export const addCarrier = async (id: number, data: any) => {
  const response = await commonServerInstance.put(
    `/api/v1/ca/rate-card/partner-config/${id}/link-carrier`,
    data
  )
  return response?.data?.data
}

export const createCarrier = async (data: any) => {
  const response = await commonServerInstance.post(
    `/api/v1/ca/rate-card/partner-carrier-config`,
    data
  )
  return response?.data?.data
}

export const toggleStatus = async (id: number) => {
  const response = await commonServerInstance.patch(
    `/api/v1/ca/rate-card/partner-carrier-config/${id}/toggle-status`
  )
  return response?.data?.data
}

// ecs_partners rows that are not yet onboarded into dw_dim_ca_partner_config.
export interface IEcsPartner {
  id: number
  name: string
}

export const fetchEcsPartners = async (): Promise<IEcsPartner[]> => {
  const response = await commonServerInstance.get(
    '/api/v1/ca/rate-card/partner-carrier-config/ecs-partners'
  )
  return response?.data?.data ?? []
}

// Add Partner from ecs_partners. Single-INSERT into dw_dim_ca_partner_config;
// carrier-1 is virtual so no dw_dim_ca_partner_carrier_config row is written.
export const addPartnerFromEcs = async (data: Record<string, any>) => {
  const response = await commonServerInstance.post(
    '/api/v1/ca/rate-card/partner-config/add',
    data
  )
  return response?.data?.data
}

// partnerId is the business partner_id (matches ecs_partners.id and
// dw_dim_ca_partner_config.partner_id), NOT dw_dim_ca_partner_config.id.
// The route path segment is legacy-named `{id}`, but the backend service
// dispatches off partner_id — see PartnerCarrierConfigService::updatePartnerConfig.
export const updatePartner = async (
  partnerId: number,
  data: Record<string, any>
) => {
  const response = await commonServerInstance.put(
    `/api/v1/ca/rate-card/partner-config/${partnerId}`,
    data
  )
  return response?.data?.data
}
